import { initializeApp } from "firebase/app";
import { initialiseFirebaseAuth } from "./auth";

let initialised = false;

export const initialiseFirebase = () => {
  if (!initialised) {
    // Only include config options required for Firebase Auth
    const firebaseConfig = {
      apiKey: "AIzaSyAziLooNNQRWDNaUpuiKKzZExOWzun65d4",
      authDomain: "mindstack-368413.firebaseapp.com",
      projectId: "mindstack-368413",
      appId: "1:717481736708:web:c7aac2416826a18a42d351",
    };

    initializeApp(firebaseConfig);
    initialiseFirebaseAuth();
    initialised = true;
  }
};
